// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

// Utils
import { Button } from '@nerdwallet/currency';
import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

// Local Components
import CardCta from '../card-cta/card-cta';

const guidesUri = cdnUri('mortgages/guides', 'pdf');

const GuideDownloadCta = ({ trackingId }) => (
  <CardCta
    iconName="House_pricetag"
    title="Welcome to NerdWallet!"
    subtitle="We are here to make home buying easy! Please click the button below to download our comprehensive home buying guide."
    trackingId={trackingId}
  >
    <Button
      primary
      href={guidesUri('NerdWallet-Home-Buying-Guide')}
      target="_blank"
    >
      Download now
    </Button>
  </CardCta>
);

GuideDownloadCta.propTypes = {
  trackingId: PropTypes.string.isRequired,
};

export default GuideDownloadCta;
